import createAxiosInstance from './Axios';

export const callBFF = async (data, baseURL, isGuest) => {
  const axiosInstance = createAxiosInstance(baseURL);
  return axiosInstance({
    url: `${data.path}${isGuest ? '/guest' : ''}`,
    method: 'post',
    data: data.form,
  });
};
